import React, { Component } from 'react';
import { RotateCcw } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { BaseErrorBoundary, ErrorFallbackProps } from '../../components/shared/BaseErrorBoundary';
import { DjayAvatar } from '../../mascot';
/**
 * PracticeErrorBoundary — Catches rendering errors in the practice session.
 *
 * Shows a friendly Djay-styled fallback UI with reset functionality.
 * Now uses BaseErrorBoundary for shared lifecycle logic (s106 P2-18).
 *
 * Co-located in practice/ domain (CL-1 s63).
 */
interface PracticeErrorBoundaryProps {
  children: React.ReactNode;
  onReset: () => void;
}
export class PracticeErrorBoundary extends Component<PracticeErrorBoundaryProps> {
  renderFallback = ({
    error,
    onReset
  }: ErrorFallbackProps): React.ReactNode => {
    return <div className="min-h-screen bg-[#FAFAF8] flex items-center justify-center p-6" data-id="element-6793">
        <Card className="max-w-lg w-full p-12 text-center shadow-2xl shadow-rose-100 border-2 border-rose-100" data-id="element-6794">
          <div className="mx-auto mb-6" data-id="element-6795">
            <DjayAvatar size="xl" emotion="thinking" data-id="element-6796" />
          </div>
          <h2 className="text-3xl font-black text-slate-900 mb-4 tracking-tight" data-id="element-6797">
            Oeps, dat ging mis!
          </h2>
          <p className="text-slate-600 mb-4 text-lg leading-relaxed font-medium" data-id="element-6798">
            Djay kon de oefensessie niet laden. Geen zorgen — probeer het
            opnieuw!
          </p>
          {process.env.NODE_ENV === 'development' && error && <div className="mb-6 p-4 bg-rose-50 rounded-lg border border-rose-200 text-left" data-id="element-6799">
              <p className="text-xs font-mono text-rose-800 break-all" data-id="element-6800">
                {error.message}
              </p>
            </div>}
          <Button onClick={() => {
          onReset();
          this.props.onReset();
        }} variant="primary" size="xxl" fullWidth className="shadow-2xl shadow-indigo-200" data-id="element-6801">
            <RotateCcw className="w-5 h-5 mr-2" data-id="element-6802" />
            Probeer opnieuw
          </Button>
        </Card>
      </div>;
  };
  render(): React.ReactNode {
    return <BaseErrorBoundary logPrefix="Practice Session" fallback={this.renderFallback} onReset={this.props.onReset} data-id="element-6803">
        {this.props.children}
      </BaseErrorBoundary>;
  }
}